import { Injectable } from '@angular/core';
import { Category } from './../interface/category/category';
import { HttpService } from './http/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TownsService {

  constructor(private _http: HttpService) { }

  public getAll(): Promise<Category[]> {
    return firstValueFrom(this._http.get('/Towns'));
  }
  public get(id: number): Promise<Category[]> {
    return firstValueFrom(this._http.get('/Towns/' + id));
  }
  public add(data: Category): Promise<Category> {
    return firstValueFrom(this._http.post('/Towns', data));
  }
  public update(id: number, data: Category): Promise<Category> {
    return firstValueFrom(this._http.patch('/Towns/', id, data));
  }
  public delete(id: number): Promise<Category> {
    return firstValueFrom(this._http.delete('/Towns/', id));
  }

}
